import React from "react";
import { Button } from "./ui/button";
import { Link } from "@/i18n/routing";
import { useTranslations } from "next-intl";

const JoinNowButton = () => {
  const t = useTranslations("general");

  return (
    <Button
      asChild
      className="bg-gradient-to-t from-primary to-second-primary rounded-full text-base md:text-xl  py-2  h-fit px-8 text-primary-foreground hover:text-primary-foreground/80 transition z-10"
    >
      <Link href="/auth/signup">{t("get_started")}</Link>
    </Button>
  );
};

export default JoinNowButton;
